import type * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

const iconBubbleVariants = cva("grid shrink-0 place-items-center rounded-full [&_svg]:shrink-0", {
  variants: {
    domain: {
      neutral: "bg-muted text-muted-foreground",
      light: "bg-domain-light-wash text-domain-light",
      climate: "bg-domain-climate-wash text-domain-climate",
      energy: "bg-domain-energy-wash text-domain-energy",
      security: "bg-domain-security-wash text-domain-security",
      flow: "bg-domain-flow-wash text-domain-flow",
    },
    filled: { true: "", false: "" },
    size: {
      sm: "size-8 [&_svg]:size-4",
      md: "size-10 [&_svg]:size-5",
      lg: "size-12 [&_svg]:size-6",
    },
  },
  compoundVariants: [
    { domain: "light", filled: true, class: "bg-domain-light text-white" },
    { domain: "climate", filled: true, class: "bg-domain-climate text-white" },
    { domain: "energy", filled: true, class: "bg-domain-energy text-white" },
    { domain: "security", filled: true, class: "bg-domain-security text-white" },
    { domain: "flow", filled: true, class: "bg-domain-flow text-white" },
  ],
  defaultVariants: { domain: "neutral", filled: false, size: "md" },
});

export function IconBubble({
  className,
  domain,
  filled,
  size,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof iconBubbleVariants>) {
  return (
    <div
      data-slot="icon-bubble"
      className={cn(iconBubbleVariants({ domain, filled, size }), className)}
      {...props}
    />
  );
}
